import { render, staticRenderFns } from "./TextOverflow.vue?vue&type=template&id=b5863bba&scoped=true&"
import script from "./TextOverflow.vue?vue&type=script&lang=js&"
export * from "./TextOverflow.vue?vue&type=script&lang=js&"
import style0 from "./TextOverflow.vue?vue&type=style&index=0&id=b5863bba&lang=scss&scoped=true&"
import style1 from "./TextOverflow.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5863bba",
  null
  
)

export default component.exports